export default (pedido) => {
  //pedido.id = `#${pedido.id}`
  let itens = pedido.itens.map(i => `%0A${i.qtda} ${i.name} ${(i.preco * i.qtda).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}`)
  if(pedido.giftvalor > 0) {
    itens = itens + `%0ADesconto: ${pedido.giftvalor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}`
  }
  return `Número do Pedido: %23${pedido.id}${itens}%0AValor Total: ${pedido.valorTotal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}`
}
